<template>
  <div class="home-container">
    <div class="video-container">
      <div class="gif-wrapper">
        <img src="../assets/home3.gif" alt="" class="gif-image">
      </div>
    </div>
    <div class="logo-container" :class="{ 'white-bg': showProductList }" style="position: absolute;top: 0;left: 0;">
      <div class="logo-wrapper">
        <img src="../assets/logo.png" alt="" class="logo">
      </div>
      <div class="menu-btn" @click="toggleMenu">
        <span :class="{ 'active': isMenuOpen }"></span>
        <span :class="{ 'active': isMenuOpen }"></span>
        <span :class="{ 'active': isMenuOpen }"></span>
      </div>
      <div class="nav-links" :class="{
      'nav-active': isMenuOpen,
      'white-bg': showProductList,
      'mobile-nav': isMobile
    }">
        <div class="nav-item nav-item2" @click="handleNavClick('/'), FisMobile()">首页</div>
        <div class="nav-item" @click="handleProductClick"
          :class="{ 'text-dark': showProductList, 'product-active': showProductList }" v-if="!isMobile">
          雾曼技术和产品
        </div>
        <div class="nav-item" @click="handleNavClick('/Dynamic')">雾曼动态</div>
        <div class="nav-item" @click="handleNavClick('/about')">关于雾曼</div>
        <div class="nav-item" @click="handleNavClick('/contact')">联系雾曼</div>
        <div class="nav-item" @click="handleNavClick('/Cooperation')">
          成为合伙人
        </div>

        <div class=" mobile-consult" @click="scrollToConsult">需求咨询</div>

      </div>
      <div class="consult-button" @click="scrollToConsult">需求咨询</div>
    </div>

    <div class="info-container" style="position: absolute; top: 0; left: 0; z-index: 100;">
      <div class="info-box">
        <span class="info-title">独创伴生雾化技术</span>
        <span class="info-subtitle">ZL 2023 1 1183009.6</span>
      </div>
      <div class="info-text">
        <div>通过技术创新提升行业标准</div>
        <div>带来更加安全、健康、智能的作业和生活环境</div>
      </div>
      <div class="contact-wrapper">
        <div class="contact-button" @click="scrollToConsult">
          <span>联系雾曼</span>
          <img src="../assets/home3.png" alt="">
        </div>
      </div>
    </div>
    <product-list v-if="showProductList" :top="70"></product-list>
  </div>
</template>

<script>
import { VuePlyr } from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import ProductList from '@/components/ProductList.vue'
export default {
  name: 'HomeHeader',
  components: {
    VuePlyr,
    ProductList
  },
  data() {
    return {
      isMenuOpen: false,
      showProductList: false,
      isMobile: false
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    // 获取播放器实例
    //const player = this.$refs.plyr.player
    // 设置自动播放
    //player.play()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleProductList() {
      this.showProductList = !this.showProductList;
    },
    scrollToConsult() {
      this.$router.push('/contact').then(() => {
        setTimeout(() => {
          window.scrollTo({
            top: 1000,
            behavior: 'smooth'
          });
        }, 500);
      });
    },

    FisMobile() {
      this.showProductList = false
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleNavClick(route) {


      this.$router.push(route);

      if (this.isMobile) {
        this.isMenuOpen = false;
      }
    },
    handleProductClick() {
      this.toggleProductList();
      if (this.isMobile) {
        this.isMenuOpen = false;
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.video-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}

.video-background {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.logo-container {
  width: 100%;
  height: 70px;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(3px);
  padding: 0 55px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1001;
}

.logo-wrapper {
  position: absolute;
}

.logo {
  width: 251px;
  height: 32px;
}

.menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 25px;
  height: 20px;
  position: absolute;
  right: 20px;
  cursor: pointer;
  z-index: 1002;
}

.menu-btn span {
  display: block;
  width: 100%;
  height: 2px;
  background: #FFFFFF;
  transition: all 0.3s ease;
}

.menu-btn span.active:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.menu-btn span.active:nth-child(2) {
  opacity: 0;
}

.menu-btn span.active:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

.nav-links {
  display: flex;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  text-align: center;
  margin: auto;
  height: 68px;
  line-height: 70px;
  cursor: pointer;
  z-index: 10;
}

.nav-item {
  padding: 0 20px;
}

.nav-item2 {
  border-bottom: 2px solid #FFFFFF;
}

.consult-button {
  background: #FFFFFF;
  border-radius: 17px;
  width: 96px;
  height: 32px;
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  position: absolute;
  right: 54px;
  cursor: pointer;
}

.info-container {
  width: 1120px;
  margin: auto;
  margin: 233px;
}

.info-box {
  width: calc(367px - 13px - 13px);
  padding: 0 13px;
  height: 48px;
  background: #ffffff91;
  border-radius: 8px;
  line-height: 48px;
  overflow: hidden;
}

.info-title {
  font-size: 20px;
  color: #041214;
  font-weight: 500;
  font-style: normal;
}

.info-subtitle {
  color: #041214;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
}

.info-text {
  font-family: 'Noto Sans SC', sans-serif;
  /* 思源黑体 */
  font-weight: 700;
  /* Bold */
  font-size: 56px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  width: 1120px;
  text-shadow: 2px 2px 4px #0a2f1e;
  /* 添加暗绿色投影 */
}


.contact-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.contact-label {
  color: #FFFFFF;
  font-size: 14px;
  margin-left: 8px;
}

.contact-button {
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  height: 48px;
  width: 158px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 第一个按钮的悬停效果 */
.contact-button:hover {
  background: #FFFFFF;
  color: #284200;
}

.contact-button:hover img {
  filter: brightness(0) saturate(100%) invert(24%) sepia(11%) saturate(2211%) hue-rotate(49deg) brightness(92%) contrast(89%);
}

/* 第二个按钮的悬停效果 */
.contact-button[style*="background: #FFFFFF"]:hover {
  background: transparent !important;
  color: #FFFFFF !important;
}

.contact-button[style*="background: #FFFFFF"]:hover img {
  filter: none;
}

.contact-button img {
  width: 16px;
  height: 16px;
}

.contact-text,
.contact-icon {
  display: none;
}

.mobile-consult {
  display: none;
  /* 默认隐藏 */
}

@media screen and (max-width: 768px) {
  .home-container {
    height: 100vh;
  }

  .logo-container {
    height: 50px;
    padding: 0 20px;
    z-index: 1002;
  }

  .logo {
    width: 150px;
    height: 20px;
  }

  .menu-btn {
    display: flex;
  }

  .nav-links {
    display: none;
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: calc(100vh - 50px);
    flex-direction: column;
    padding: 20px 0;
    margin: 0;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.95);
  }

  .nav-links.nav-active {
    display: flex;
  }

  .nav-item {
    padding: 15px 20px;
    line-height: normal;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .consult-button {
    display: none;
  }

  .mobile-consult {
    display: block;
    /* 在移动端显示 */
    background: #FFFFFF;
    color: #0A2E43;
    margin: 10px 20px;
    border-radius: 17px;
    height: 40px;
    line-height: 40px;
  }

  .info-container {
    margin: 100px 20px;
    width: auto;
    position: relative;
  }

  .info-text {
    width: 100%;
    font-size: 32px;
  }

  .info-box {
    width: 100%;
  }

  .contact-button {
    width: 100%;
  }
}

.white-bg {
  background: #FFFFFF !important;
}

.text-dark {
  color: #0A2E43 !important;
}

.nav-links.white-bg .nav-item {
  color: #0A2E43;
}

.product-active {
  color: #FF0000 !important;
  border-bottom: 2px solid #FF0000;
}

.mobile-nav {
  padding: 20px 0;
}

.gif-wrapper {
  width: 100%;
  height: 100%;
}

.gif-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
</style>